import { useCallback, useRef, type ReactNode } from 'react';
import { campaignCopy, useCampaignCapabilitiesStore } from '@discovr/features';
import { BrandApprovalRollbackDialog, type DialogHandle, type RowOpener } from './CreatorsTab.rollbackDialog';

interface CreatorsRollback {
  /** Null when this viewer may not roll back (non-admin lane, public view, no permission). */
  openRollback: RowOpener | null;
  blockedReason: string | null;
  dialogs: ReactNode;
}

// Dialog state lives in a child so opening it does not rebuild the table columns.
export function useCreatorsRollback(enabled: boolean): CreatorsRollback {
  const handle = useRef<DialogHandle>(null);
  const isWired = useCampaignCapabilitiesStore((s) => s.rollbackBrandApproval !== null);
  const open = useCallback<RowOpener>((row, opener) => handle.current?.openRollback(row, opener), []);
  return {
    openRollback: enabled ? open : null,
    blockedReason: isWired ? null : campaignCopy.creator.hold.actionUnavailable,
    dialogs: enabled ? <BrandApprovalRollbackDialog ref={handle} /> : null,
  };
}
